import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { api, createRestoreParkedBasketUrl } from "@is/services";
import { BasketItem } from "@is/types";

type State = {
  isPending: boolean;
  error: Error | null;
  data: RestoredBasket | null;
};

type RestoredBasket = {
  metadata: Record<string, unknown>;
  basket: {
    sessionId: string;
    items: BasketItem[];
  };
};

async function handleBasketRestore(basketId: string): Promise<RestoredBasket> {
  const restoreParkedBasketUrl = createRestoreParkedBasketUrl(basketId);

  const data = (await api.post(restoreParkedBasketUrl)) as RestoredBasket;

  return data;
}

export const useRestoreParkedBasket = (): [
  State,
  (basketId: string) => Promise<RestoredBasket>
] => {
  const [{ isPending, error, data }, dispatch] = usePromise<RestoredBasket>();

  const restoreParkedBasket = useCallback(
    async (basketId: string) => {
      const data = await dispatch(handleBasketRestore(basketId));
      return data;
    },
    [dispatch]
  );

  return [{ isPending, error, data }, restoreParkedBasket];
};
